import {
  constSafetyBanner,
  constSafetyThumb,
  constAssetBanner,
  constAssetThumb,
  constEquipmentBanner,
  constEquipmentThumb,
  logisticsAssetBanner,
  logisticsAssetThumb,
  logisticsSafetyBanner,
  logisticsSafetyThumb,
  retailOfficeBanner,
  retailOfficeThumb,
  manufacturingProcessBanner,
  manufacturingProcessThumb,
  manufacturingSteelBanner,
  manufacturingSteelThumb,
  medicalPatientBanner,
  medicalPatientThumb,
  medicalWasteBanner,
  medicalWasteThumb,
  retailExhibitionBanner,
  retailExhibitionThumb,
  sampleSolutionThumb,
  sampleSolutionThumb2,
  constSopBanner,
  constManageBanner,
  cityTrafficBanner,
  cityTrafficThumb,
  cityDigitalBanner,
  cityDigitalThumb,
  manufacturingForkliftBanner,
  manufacturingForkliftThumb,
  constSopThumb,
  constManageThumb,
  digitaltwinThumb,
  digitaltwinBanner,
  publicFireBanner,
  publicFireThumb,
  publicCrosswalkBanner,
  publicCrosswalkThumb,
  publicSafetyBanner,
  publicSafetyThumb,
  retailMobileThumb,
  retailMobileBanner,
  educationSafetyBanner,
  educationSafetyThumb,
} from '@assets/images/solution';

export const constructionSafety = {
  banner: constSafetyBanner,
  thumb: constSafetyThumb,
};

export const constructionAsset = {
  banner: constAssetBanner,
  thumb: constAssetThumb,
};

export const constructionEquipment = {
  banner: constEquipmentBanner,
  thumb: constEquipmentThumb,
};

export const constructionSop = {
  banner: constSopBanner,
  thumb: constSopThumb,
};

export const constructionManage = {
  banner: constManageBanner,
  thumb: constManageThumb,
};

export const logisticsAsset = {
  banner: logisticsAssetBanner,
  thumb: logisticsAssetThumb,
};

export const logisticsSafety = {
  banner: logisticsSafetyBanner,
  thumb: logisticsSafetyThumb,
};

export const retailOffice = {
  banner: retailOfficeBanner,
  thumb: retailOfficeThumb,
};

export const manufacturingProcess = {
  banner: manufacturingProcessBanner,
  thumb: manufacturingProcessThumb,
};

export const manufacturingSteel = {
  banner: manufacturingSteelBanner,
  thumb: manufacturingSteelThumb,
};

export const medicalPatient = {
  banner: medicalPatientBanner,
  thumb: medicalPatientThumb,
};

export const medicalWaste = {
  banner: medicalWasteBanner,
  thumb: medicalWasteThumb,
};

export const retailExhibition = {
  banner: retailExhibitionBanner,
  thumb: retailExhibitionThumb,
};

export const retailCart = {
  banner: retailExhibitionBanner,
  thumb: sampleSolutionThumb2,
};
export const retailMobile = {
  banner: retailMobileBanner,
  thumb: retailMobileThumb,
};

export const cityTraffic = {
  banner: cityTrafficBanner,
  thumb: cityTrafficThumb,
};
export const cityDigital = {
  banner: cityDigitalBanner,
  thumb: cityDigitalThumb,
};
export const manufacturingForklift = {
  banner: manufacturingForkliftBanner,
  thumb: manufacturingForkliftThumb,
};

export const digitaltwin = {
  banner: digitaltwinThumb,
  thumb: digitaltwinBanner,
};

export const publicFire = {
  banner: publicFireBanner,
  thumb: publicFireThumb,
};

export const publicSafety = {
  banner: publicSafetyBanner,
  thumb: publicSafetyThumb,
};

export const publicCrosswalk = {
  banner: publicCrosswalkBanner,
  thumb: publicCrosswalkThumb,
};

export const educationSafety = {
  banner: educationSafetyBanner,
  thumb: educationSafetyThumb,
};
